import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Aboutus from './Pages/Aboutus/Aboutus';
import Landingpage from './Pages/Landinpage/Landingpage';
import Blog from './Pages/Blog/Blog';
import Portfolio from './Pages/Portfolio/Portfolio';
import Blogdetails from './Pages/Blog details/Blogdetails';
import FAQ from './Pages/FAQ/FAQ';
import Cookie from './Pages/Cookie Policy/Cookie';
import TermsofService from './Pages/Terms of Service/TermsofService';
import Login from './Pages/Authentication/Reset Password/Login';
import Dashboard from './Pages/Dashboard/Dashboard';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Landingpage />} />
        <Route path='/about_us' element={<Aboutus />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/blog_details' element={<Blogdetails />} />
        <Route path='/faq' element={<FAQ />} />
        <Route path='/cookie' element={<Cookie />} />
        <Route path='/terms_of_service' element={<TermsofService />} />
        <Route path='/login' element={<Login />} />
        <Route path='/dashboard' element={<Dashboard />} /> 
      </Routes>
    </Router>
  );
}

export default App;
